module.exports = {
	"config": {
		"linkPrefix": "/doxity-simpleton",
		"name": "doxity-simpleton",
		"version": "1.0.0",
		"description": "Solidity Documentation",
		"buildTime": "2017-12-01T22:54:04.573Z",
		"target": "doxity",
		"src": "contracts/*",
		"dir": "pages/docs",
		"out": "docs",
		"author": "Ryan Hendricks",
		"homepage": "https://ryanhendricks.github.io/doxity-simpleton/",
		"interaction": {}
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/home/ryan/Git/doxity-simpleton/doxity/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "docs",
				"stem": "_template",
				"path": "docs/_template.jsx",
				"absolute": "/home/ryan/Git/doxity-simpleton/doxity/docs/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "docs/_template.jsx",
			"templatePath": "/docs/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ICO.json",
				"ext": "json",
				"name": "ICO",
				"extname": ".json",
				"basename": "ICO.json",
				"dirname": "docs",
				"stem": "ICO",
				"path": "docs/ICO.json",
				"absolute": "/home/ryan/Git/doxity-simpleton/doxity/docs/ICO.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ICO.json",
			"path": "/docs/ICO/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Migrations.json",
				"ext": "json",
				"name": "Migrations",
				"extname": ".json",
				"basename": "Migrations.json",
				"dirname": "docs",
				"stem": "Migrations",
				"path": "docs/Migrations.json",
				"absolute": "/home/ryan/Git/doxity-simpleton/doxity/docs/Migrations.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Migrations.json",
			"path": "/docs/Migrations/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "",
				"stem": "index",
				"path": "index.md",
				"absolute": "/home/ryan/Git/doxity-simpleton/doxity/index.md",
				"isAbsolute": false
			},
			"requirePath": "index.md",
			"path": "/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 386
// module chunks = 0